export default __webpack_public_path__ + "static/media/Ongoingsupport.e97741f4.svg";